import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    Alert,
    Button,
    CardActions,
    CardContent,
    CardHeader,
    FormControlLabel,
    Grid,
    Switch,
    TextField,
} from '@mui/material';
import { setModal } from '../../../../../Common/App';
import { DialogCard, Loader } from '../../../../../../Components';
import { addVenue, updateVenue } from '../../../Redux/Action';

export const VenueModal = ({ item }) => {

    const dispatch = useDispatch();
    const [disabled] = useState(false);
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({
        id: null,
        venue_name: '',
        code: '',
        address: '',
        notes: '',
        is_active: true,
    });

    useEffect(() => {
        if (item) {
            setData({
                id: item.id,
                venue_name: item.venue_name || '',
                code: item.code || '',
                address: item.address || '',
                notes: item.notes || '',
                is_active: item.is_active !== false && item.is_active !== 0,
            });
        }
    }, [item]);

    const handleSaveOrUpdate = async () => {

        if (!data.venue_name.trim()) {
            setErrors({ venue_name: 'Venue name is required' });
            setMessage('Venue name is required');
            return;
        }

        setIsLoading(true);
        const payload = {
            venue_name: data.venue_name.trim(),
            code: data.code?.trim() || null,
            address: data.address?.trim() || null,
            notes: data.notes?.trim() || null,
            is_active: !!data.is_active,
        };

        if (data.id) {
            payload.id = data.id;
            await updateVenue({ dispatch, data: payload }).then((res) => {
                setIsLoading(false);
                if (res.success) {
                    dispatch(setModal({ component: null, open: false }));
                } else {
                    setErrors(res.errors || {});
                    setMessage(res.message || '');
                }
            });
        } else {
            await addVenue({ dispatch, data: payload }).then((res) => {
                setIsLoading(false);
                if (res.success) {
                    dispatch(setModal({ component: null, open: false }));
                } else {
                    setErrors(res.errors || {});
                    setMessage(res.message || '');
                }
            });
        }
    };

    const handleChange = (e) => {
        setErrors({});
        setMessage('');
        const { name, value, checked, type } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleActiveChange = (e) => {
        setErrors({});
        setMessage('');
        setData((prev) => ({
            ...prev,
            is_active: e.target.checked,
        }));
    };

    return (
        <DialogCard>
            <CardHeader
                title={data.id ? 'Edit Venue' : 'Add Venue'}
                avatar={<Loader isLoading={isLoading} type="linear" />}
            />
            <CardContent>
                {message && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {message}
                    </Alert>
                )}
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Venue name"
                            name="venue_name"
                            value={data.venue_name}
                            onChange={handleChange}
                            error={!!errors.venue_name}
                            helperText={errors.venue_name}
                            disabled={disabled}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Code"
                            name="code"
                            value={data.code}
                            onChange={handleChange}
                            error={!!errors.code}
                            helperText={errors.code}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            control={(
                                <Switch
                                    checked={!!data.is_active}
                                    onChange={handleActiveChange}
                                    disabled={disabled}
                                    color="primary"
                                />
                            )}
                            label="Active"
                        />
                    </Grid>
                    {/* <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Address"
                            name="address"
                            value={data.address}
                            onChange={handleChange}
                            error={!!errors.address}
                            helperText={errors.address}
                            disabled={disabled}
                            multiline
                            minRows={2}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Notes"
                            name="notes"
                            value={data.notes}
                            onChange={handleChange}
                            error={!!errors.notes}
                            helperText={errors.notes}
                            disabled={disabled}
                            multiline
                            minRows={2}
                        />
                    </Grid> */}
                </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: 'flex-end' }}>
                <Button
                    variant="outlined"
                    onClick={() => dispatch(setModal({ component: null, open: false }))}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSaveOrUpdate}
                    disabled={isLoading || disabled}
                >
                    {isLoading ? 'Saving...' : (data.id ? 'Update' : 'Add')}
                </Button>
            </CardActions>
        </DialogCard>
    );
};
